export {
  type ISearchResults,
  useInfiniteSearchQuery,
} from "./useInfiniteSearchQuery";
